import React from 'react';
import NotificationBell from '../../NotificationBell';

interface FloatingNotificationBellProps {
  className?: string;
}

export function FloatingNotificationBell({ className = '' }: FloatingNotificationBellProps) {
  return (
    <div className={`fixed top-20 right-4 z-30 ${className}`}>
      <div className="bg-white rounded-full shadow-lg border border-gray-200 p-2">
        <NotificationBell />
      </div>
    </div>
  );
} 